"use client";

import { useTileInteractions } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductTile/__internal__/components/TileInteractionsContextProvider";
import { trackProductTileBrandLinkHover } from "@faire/web-api--source/events/productTile/hover/brandLink";
import { Link } from "@faire/web/ui/LinkAnchor";
import React from "react";

export const BrandLink: React.FC<{
  dataTestId?: string;
  children: React.ReactNode;
}> = (props) => {
  const { tileActions, props: tileProps } = useTileInteractions();

  const onClick = () => {
    tileActions?.onBrandClick?.();
  };

  return (
    <Link
      onClick={onClick}
      onMouseEnter={() => {
        tileActions?.onBrandLinkFocus?.();
        trackProductTileBrandLinkHover();
      }}
      onMouseLeave={() => {
        tileActions?.onBrandLinkBlur?.();
      }}
      onFocus={() => {
        tileActions?.onBrandLinkFocus?.();
      }}
      onBlur={() => {
        tileActions?.onBrandLinkBlur?.();
      }}
      onTouchStart={() => {
        tileActions?.onBrandLinkFocus?.();
        trackProductTileBrandLinkHover();
      }}
      data-test-id={props.dataTestId ?? ""}
      to={tileProps?.brandLinkProps?.brandUrl ?? ""}
      replace={tileProps?.brandLinkProps?.replace}
    >
      {props.children}
    </Link>
  );
};
